import { useQuery } from 'react-query';
import axios from '../utils/axios-util';

const getVisualisationGraphById = (customerName, vid) => {
  return axios({
    url: '/dashboards/' + customerName + '/visualisation/' + vid,
    method: 'get'
  });
};

const useGetVisualisationGraphById = (customerName, vid) => {
  return useQuery(["get","graphById", vid], () => getVisualisationGraphById(customerName, vid), {
    enabled: !!customerName && !!vid
  });
};

export default useGetVisualisationGraphById;